import { render, staticRenderFns } from "./AdminViewPastor.vue?vue&type=template&id=6003e9d8&scoped=true&"
import script from "./AdminViewPastor.vue?vue&type=script&lang=js&"
export * from "./AdminViewPastor.vue?vue&type=script&lang=js&"
import style0 from "./AdminViewPastor.vue?vue&type=style&index=0&id=6003e9d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6003e9d8",
  null
  
)

export default component.exports